import { render, staticRenderFns } from "./ViewHub.vue?vue&type=template&id=b47a3e78"
import script from "./ViewHub.vue?vue&type=script&lang=js"
export * from "./ViewHub.vue?vue&type=script&lang=js"
import style0 from "./ViewHub.vue?vue&type=style&index=0&id=b47a3e78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports